import { render } from "./NotFound.vue?vue&type=template&id=7a66e9b8"
const script = {}
script.render = render

export default script